import styles from './range.module.css';

import { Text } from "../text/text";

export const Range = ({ min = 0, max = 100, step = 1, value, onChange, label, withValue = false, ...props }) => {
    return (
        <div className={styles.range} onClick={(e) => e.stopPropagation()}>
            {label && <Text as="label" variant="caption" className={styles.label} >{label}</Text>}
            <div className={styles.range_container}>
                <input
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={(e) => onChange(+e.target.value)}
                    className={styles.range_input}
                    style={{ "--value": (value - min) / (max - min) * 100 + "%" }}
                    {...props}
                />
                {withValue && <Text as="div" variant="body" className={styles.value} >{value} / {max}</Text>}
            </div>
        </div>
    )
}